import { createStore } from "zustand/vanilla";
export const createInlineEdit = () => createStore((set, get) => ({
    mode: "reading",
    targetId: null,
    draft: "",
    beginEdit(id, value) {
        set({ mode: "editing", targetId: id, draft: value });
    },
    setDraft(value) {
        set({ draft: value });
    },
    commit() {
        const { mode, targetId, draft } = get();
        if (mode !== "editing" || targetId == null)
            return { kind: "noop" };
        set({ mode: "reading", targetId: null, draft: "" });
        const trimmed = draft.trim();
        return trimmed === "" ? { kind: "revert", id: targetId } : { kind: "save", id: targetId, value: trimmed };
    },
    cancel() {
        set({ mode: "reading", targetId: null, draft: "" });
    },
}));
export const createRapidAdd = () => createStore((set, get) => ({
    mode: "idle",
    draft: "",
    begin() {
        set({ mode: "composing", draft: "" });
    },
    setDraft(value) {
        set({ draft: value });
    },
    commit() {
        const { mode, draft } = get();
        if (mode !== "composing")
            return { kind: "noop" };
        const name = draft.trim();
        if (name === "")
            return { kind: "noop" };
        set({ draft: "" }); // reopen blank, stay composing (focus retained)
        return { kind: "create", name };
    },
    discard() {
        set({ mode: "idle", draft: "" });
    },
}));
export const createUndoManager = (capacity = 20) => {
    const buffer = [];
    return {
        push(entry) {
            buffer.push(entry);
            if (buffer.length > capacity)
                buffer.shift();
        },
        async undo() {
            const entry = buffer.pop();
            if (!entry)
                return false;
            await entry.invert();
            return true;
        },
        canUndo: () => buffer.length > 0,
        size: () => buffer.length,
    };
};
//# sourceMappingURL=uiState.js.map